export default __webpack_public_path__ + "static/media/BLR17.7275d0dc.jpg";